export const currentEnvironment = () =>
  process.env.APP_ENV ||
  process.env.REACT_APP_ENV ||
  process.env.NEXT_PUBLIC_ENV ||
  process.env.NODE_ENV ||
  'production';
